import { Cancel, Search } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import React from "react";
import { useTranslation } from "react-i18next";
import { IProvinceProp } from "../props";

const FilterModal: React.FC<{
  setSearchText: (text: string) => void;
  onClose: () => void;
  selectedProvince: number | undefined;
  setSelectedProvince: (id: number) => void;
  open: boolean;
  startDate: Date | undefined;
  endDate: Date | undefined;
  provinces: IProvinceProp[];
  setStartDate: (date: Date | undefined) => void;
  setEndDate: (date: Date | undefined) => void;
}> = ({
  selectedProvince,
  startDate,
  provinces,
  endDate,
  open,

  setSelectedProvince,
  setSearchText,
  setStartDate,
  setEndDate,
  onClose,
}) => {
  const { t } = useTranslation();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "80%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 1,
    p: 2,
  };

  return (
    <Modal
      // className="lg:hidden"
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="flex flex-col gap-2">
          <div className="flex justify-between items-center">
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {t("filter")}
            </Typography>
            <IconButton onClick={onClose}>
              <Cancel />
            </IconButton>
          </div>
          <TextField
            className="bg-[#ffffff] rounded-full"
            size="small"
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            placeholder={t("search")}
            sx={{
              "& .MuiOutlinedInput-root": {},
              "& .MuiOutlinedInput-input": {},
            }}
          />
          <FormControl
            fullWidth
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {},
              "& .MuiOutlinedInput-input": {},
            }}
          >
            <InputLabel id="role-label">{t("select_province")}</InputLabel>
            <Select
              labelId="role-label"
              id={"provinces"}
              name={"provinces"}
              label={t("select_province")}
              value={selectedProvince}
              onChange={(val) => {
                val.target.value &&
                  typeof val.target.value === "number" &&
                  setSelectedProvince(val.target.value);
              }}
              renderValue={(val) => {
                return (
                  <p>
                    {
                      provinces?.filter((x) => x.provinceId === val)[0]
                        .provinceName
                    }
                  </p>
                );
              }}
            >
              {provinces?.map((e) => {
                return (
                  <MenuItem key={e.provinceId} value={e.provinceId}>
                    <Checkbox
                      checked={selectedProvince === e.provinceId}
                      size="small"
                    />
                    <ListItemText primary={e.provinceName} />
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <Divider />
          <DatePicker
            label={t("start_date")}
            format="dd/MM/yyyy"
            value={startDate}
            onChange={(date) => setStartDate(date ?? undefined)}
            sx={{
              "& .MuiOutlinedInput-root": {},
              "& .MuiOutlinedInput-input": {},
            }}
          />
          <DatePicker
            label={t("end_date")}
            value={endDate}
            onChange={(date) => setEndDate(date ?? undefined)}
            sx={{
              "& .MuiOutlinedInput-root": {},
              "& .MuiOutlinedInput-input": {},
            }}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default FilterModal;
